import sha1 from 'sha1'

const _sign = (ticket, timestamp, noncestr) => {
  let params = [noncestr, ticket, timestamp]
  let str = params.sort().join('')
  let sha = sha1(str)
  return sha
}

const createNonce = () =>
  Math.random()
    .toString(36)
    .substr(2, 15)
const createTimestamp = () => parseInt(new Date().getTime() / 1000, 10) + ''

export const sign = (ticket, url) => {
  var noncestr = createNonce()
  var timestamp = createTimestamp()
  var signature = _sign(ticket, timestamp, noncestr)

  return {
    noncestr: noncestr,
    timestamp: timestamp,
    signature: signature,
  }
}
